import { cn } from '@/lib/utils'

interface BookmarkIndicatorProps {
  className?: string
  isActive?: boolean
}

export const BookmarkIndicator = ({ className, isActive = false }: BookmarkIndicatorProps) => {
  return (
    <div className={cn(
      "absolute left-0 top-0 w-1 h-full transition-all duration-300 ease-in-out",
      isActive 
        ? "opacity-100 scale-y-100 bg-admin-text" 
        : "opacity-0 scale-y-0 bg-transparent",
      "origin-top rounded-r-sm",
      className
    )}>
      {/* Pequeño detalle en la parte superior como una marca de página real */}
      <div className={cn(
        "absolute -top-1 left-0 w-1 h-3 transition-all duration-300 ease-in-out",
        isActive 
          ? "opacity-100 bg-admin-text rounded-t-sm" 
          : "opacity-0 bg-transparent"
      )} />
    </div>
  )
}

export default BookmarkIndicator